// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mdc-dialog__actions {
  display: contents;
}

.warning-icon {
  font-size: 60px;
  text-align: center;
  color: #ffca28;
}

.error-icon {
  font-size: 60px;
  text-align: center;
  color: red;
}

.check-icon {
  font-size: 60px;
  text-align: center;
  color: #41c300;
}

.mat-icon {
  height: auto;
  width: auto;
}

.mat-dialog-actions {
  margin-bottom: auto;
}

.mat-dialog-content {
  margin: auto;
}

.mat-mdc-dialog-container .mdc-dialog__surface {
  padding: 64px !important;
}

.mat-mdc-button.mat-mdc-button-base,
.mat-mdc-raised-button.mat-mdc-button-base,
.mat-mdc-unelevated-button.mat-mdc-button-base,
.mat-mdc-outlined-button.mat-mdc-button-base {
  height: 36px;
  min-width: 125px;
}

.check-icon {
  font-size: 40px;
  text-align: center;
  color: white;
  height: 40px;
  width: 40px;
}

.icon-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #ACA100;
  color: #fff;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
